module.exports = __webpack_public_path__ + "static/media/MuliRegular.a7791684.woff2";